const remountDetailRoutes = new Set([
  'document-receipt-update',
  'document-invoice-update',
  'document-credit-update',
  'document-debit-update',
]);

export function documentViewKey(route, componentKey) {
  if (remountDetailRoutes.has(route.name) && route.params && route.params.id) {
    return `${componentKey}:${route.name}:${route.params.id}`;
  }
  return componentKey;
}
